import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import "./VersionPortalWeb.css";

const VersionPortalWeb = ({ dissmiss }) => {
  const { textosState } = useContext(PortalContext);

  return (
    <div className="ptur-versionApp-container">
      <div className="ptur-versionApp-header modalHeader">
        <span className="rb18m c-white">
          {textosState.textos.data?.nuevaVersion?.nombre}
        </span>

        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
      <div className="ptur-versionApp-body modalBody">
        <span className="rb18m c-black">
          Le solicitamos que actualice su portal web a la última versión. Para
          ello, recargue la pagina en la que se encuentra.
        </span>
        <div className="ptur-versionApp-btnCont">
          <button
            onClick={dissmiss}
            className="ptur-versionApp-btn bgc-danger rb16m c-white"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default VersionPortalWeb;
